import Global from '../global-selectors';
import { ShipstationConnectReader } from '../shipstation-connect/shipstation-connect-reader';
import { LocalStorageService } from '../../services/local-storage-service';
import { SCAN_PRINTER_KEY, SCAN_MODE_KEY, availableModes } from '../../scan/constants';

const flattenPrinters = (a, b) => [...a, ...b.printers];

const getAllPrinters = (state) => Global.selectConnectPrinters(state).reduce(flattenPrinters, []);

export const getDefaultMode = () => {
  const mode = LocalStorageService.getItem(SCAN_MODE_KEY);
  if (mode) {
    return mode.mode;
  }
  return availableModes.verifyAndPrint;
};

export class ScanToPrintReader {
  constructor({ state }) {
    if (!state) {
      throw new Error(`expected value for state, got: ${state}`);
    }
    this.state = state;
    this.connect = new ShipstationConnectReader({ state });
  }

  get hasPrinter() {
    return !!this.printer;
  }

  get defaultScanPrinter() {
    const printer = LocalStorageService.getItem(SCAN_PRINTER_KEY);
    if (printer) {
      return printer;
    }
    return {};
  }

  get printer() {
    const printers = getAllPrinters(this.state);
    const localStoragePrinter = { ...this.defaultScanPrinter };
    const scanToPrintPrinterId = Global.selectScanToPrintPrinterId(this.state) || localStoragePrinter.printerId;
    const scanToPrintWorkstationId = Global.selectScanToPrintWorkstationId(this.state) || localStoragePrinter.workstationId;
    if (scanToPrintPrinterId && scanToPrintWorkstationId) {
      return printers.find((p) => p.id === scanToPrintPrinterId && p.workstationId === scanToPrintWorkstationId);
    }
    const defaultPrinter = Global.selectPrintSettingsLabelPrintSettings(this.state) || {};
    return printers.find((p) => p.id === defaultPrinter.id && p.workstationId === defaultPrinter.workstationId);
  }

  get isOrderSearch() {
    const { orders, searchValue } = this.orderSearch;
    return !!orders && !!searchValue;
  }

  get isSearching() {
    const { isSearching } = this.orderSearch || {};
    return !!isSearching;
  }

  get orderSearch() {
    return Global.selectScanToPrintOrderSearchResult(this.state);
  }

  get hasStatus() {
    return this.status !== 'zero';
  }

  get status() {
    const { status } = Global.selectScanToPrintStatusIndicator(this.state);
    return status;
  }

  get hasError() {
    return this.errors && this.errors.length > 0;
  }

  get errors() {
    return Global.selectScanToPrintErrorMessages(this.state);
  }

  get inPrintMode() {
    return this.mode.indexOf('Print') > -1;
  }

  get inVerifyMode() {
    return this.mode.indexOf('verify') > -1;
  }

  get inVerifyOnlyMode() {
    return this.mode === availableModes.verify;
  }

  get defaultMode() {
    return getDefaultMode();
  }

  get mode() {
    return Global.selectScanToPrintMode(this.state) || this.defaultMode;
  }

  get isHeaderFocused() {
    return Global.selectScanToPrintIsHeaderFocused(this.state);
  }

  get salesOrderId() {
    const fulfillmentPlanId = Global.selectScanToPrintFulfillmentPlanId(this.state);
    const [salesOrderId] =
      Global.selectEntitiesFulfillmentPlanProperty(this.state, {
        fulfillmentPlanId,
        property: 'salesOrdersFulfilledIds',
      }) || [];
    return salesOrderId;
  }

  get scale() {
    const { allScales = [] } = this.connect;

    const selectedScaleId = Global.selectScanToPrintScaleId(this.state);
    if (selectedScaleId) {
      return allScales.find((s) => s.id === selectedScaleId);
    }

    const { scale } = this.connect;
    return scale;
  }
}
